import {
  apiGetConstituencies,
  apiGetDistricts,
  apiGetLocalGovernment,
  apiGetParties,
  apiGetPosition,
  apiGetState,
} from "../api/adhoc";
import { apiGetRepresentative } from "../api/home";
import { RepresentativeApiProp } from "../interface/api";

// First, define the interfaces for your data structure
export interface State {
  id: number;
  name: string;
  // Add other state properties as needed
}

export interface Position {
  id: number;
  title: string;
  // Add other state properties as needed
}

interface ApiResponse {
  data: {
    results?: State[];
    // Other possible response properties
  };
  status: number;
}

export interface SelectOption {
  value: string | number;
  label: string;
}

interface ErrorResponse {
  data: {};
  status: string;
  details?: string;
}
// Function to transform states data to select options
export const transformStatesToOptions = (states: State[]): SelectOption[] => {
  return states.map((state) => ({
    value: state.id,
    label: state.name,
  }));
};

// Function to get states with proper type handling
export const getStates = async (): Promise<SelectOption[]> => {
  try {
    const response = await apiGetState();

    // Check if response is error response
    if ("details" in response) {
      console.warn("Error fetching states:", response.details);
      return [];
    }

    // Type guard to ensure response has expected structure
    if (response?.data && Array.isArray(response.data)) {
      return transformStatesToOptions(response.data);
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return [];
  } catch (error) {
    console.error("Error in getStates:", error);
    return [];
  }
};

export const getLgaById = async (stateId: string): Promise<SelectOption[]> => {
  try {
    const response = await apiGetLocalGovernment(stateId);

    // Check if response is error response
    if ("details" in response) {
      console.warn("Error fetching states:", response.details);
      return [];
    }

    // Type guard to ensure response has expected structure
    if (response?.data && Array.isArray(response.data)) {
      return transformStatesToOptions(response.data);
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return [];
  } catch (error) {
    console.error("Error in getStates:", error);
    return [];
  }
};

export const getDistrict = async (stateId: string): Promise<SelectOption[]> => {
  try {
    const response = await apiGetDistricts(stateId);

    // Check if response is error response
    if ("details" in response) {
      console.warn("Error fetching states:", response.details);
      return [];
    }

    // Type guard to ensure response has expected structure
    if (response?.data && Array.isArray(response.data)) {
      return transformStatesToOptions(response.data);
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return [];
  } catch (error) {
    console.error("Error in getStates:", error);
    return [];
  }
};

export const getConstituents = async (stateId: string): Promise<SelectOption[]> => {
  try {
    const response = await apiGetConstituencies(stateId);

    // Check if response is error response
    if ("details" in response) {
      console.warn("Error fetching states:", response.details);
      return [];
    }

    // Type guard to ensure response has expected structure
    if (response?.data && Array.isArray(response.data)) {
      return transformStatesToOptions(response.data);
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return [];
  } catch (error) {
    console.error("Error in getStates:", error);
    return [];
  }
};

export const transformPositionToOptions = (
  states: Position[]
): SelectOption[] => {
  return states.map((state) => ({
    value: state.id,
    label: state.title,
  }));
};

export const getPosition = async (): Promise<SelectOption[]> => {
  try {
    const response = await apiGetPosition();

    // Check if response is error response
    if ("details" in response) {
      console.warn("Error fetching states:", response.details);
      return [];
    }

    // Type guard to ensure response has expected structure
    if (response?.data && Array.isArray(response.data)) {
      return transformPositionToOptions(response.data);
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return [];
  } catch (error) {
    console.error("Error in getStates:", error);
    return [];
  }
};

export const getParty = async (): Promise<SelectOption[]> => {
  try {
    const response = await apiGetParties();

    // Check if response is error response
    if ("details" in response) {
      console.warn("Error fetching states:", response.details);
      return [];
    }

    // Type guard to ensure response has expected structure
    if (response?.data && Array.isArray(response.data)) {
      return transformStatesToOptions(response.data);
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return [];
  } catch (error) {
    console.error("Error in getStates:", error);
    return [];
  }
};


